import { store } from 'reactApp/store';
import { showSnackbarAction, hideSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarActionTypes, SnackbarItem } from 'reactApp/modules/snackbar/snackbar.types';

class SnackbarController {
    public showSnackbar = (item: SnackbarItem): SnackbarActionTypes => store.dispatch(showSnackbarAction(item));

    public hideSnackbar = (id: string): SnackbarActionTypes => store.dispatch(hideSnackbarAction(id));
}

const snackbarController = new SnackbarController();

export { snackbarController };
